var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择社群",
        visible: _vm.isshowAssociation,
        width: "60%",
        top: "8vh",
        "before-close": _vm.closedAssociationDialong,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isshowAssociation = $event
        },
      },
    },
    [
      _c("div", { staticClass: "dialogMain" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-form",
              { staticClass: "demo-form-inline", attrs: { inline: true } },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择主体" },
                        model: {
                          value: _vm.associationParams.corpId,
                          callback: function ($$v) {
                            _vm.$set(_vm.associationParams, "corpId", $$v)
                          },
                          expression: "associationParams.corpId",
                        },
                      },
                      _vm._l(_vm.corpList, function (item, index) {
                        return _c("el-option", {
                          key: item.corpId,
                          attrs: { label: item.enterprise, value: item.corpId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.associationParams[_vm.selectVal],
                          callback: function ($$v) {
                            _vm.$set(_vm.associationParams, _vm.selectVal, $$v)
                          },
                          expression: "associationParams[selectVal]",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            attrs: { slot: "prepend", placeholder: "请选择" },
                            on: {
                              change: function ($event) {
                                _vm.associationParams.search = ""
                              },
                            },
                            slot: "prepend",
                            model: {
                              value: _vm.selectVal,
                              callback: function ($$v) {
                                _vm.selectVal = $$v
                              },
                              expression: "selectVal",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "社群名称", value: "search" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: {
                      click: function ($event) {
                        _vm.associationParams.page = 1
                        _vm.getGroupchatList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-s-table", {
              ref: "associationRefs",
              attrs: {
                columns: _vm.columnsAssociationSel,
                data: _vm.associationList,
                "header-row-class-name": !_vm.multiple ? "noneCheck" : "",
                "row-key": "chatId",
                height: "500px",
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagebox" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.associationParams.page,
                    "page-sizes": [10, 20, 30, 40],
                    "page-size": _vm.associationParams.size,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.totalAssociation,
                    background: "",
                  },
                  on: {
                    "size-change": _vm.handleSizeChangeAssociation,
                    "current-change": _vm.handleCurrentChangeAssociation,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            [
              _c("span", [_vm._v("已选择")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      _vm.selectData = []
                      _vm.associationTags = []
                      _vm.$refs.associationRefs.clearSelection()
                    },
                  },
                },
                [_vm._v("全部取消")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tagMain" },
            _vm._l(_vm.associationTags, function (item) {
              return _c(
                "el-tag",
                {
                  key: item.chatId,
                  attrs: { closable: "" },
                  on: {
                    close: function ($event) {
                      return _vm.tagClose(
                        _vm.associationTags,
                        item.chatId,
                        "chatId"
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closedAssociationDialong } }, [
            _vm._v("取 消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.submitAssociation },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }